/** The page counts of a library pick, read in chunks; the ids are sorted, so the same pick in another order is one entry. */
export const libraryPageCountsKey = (dealId: string, documentIds: string[]) =>
	['dealstack-ai', 'ingestion', 'library-page-counts', dealId, documentIds] as const;
